import { merchantGroupSchema } from "./../../shared/merchantGroupSchema";
import { z } from "zod";
import {
  allowedPeriodSchema,
  categoryItemSchema,
  countryCodeSchema,
  typeLimitSchema,
} from "./_shared";

export const createRulePayloadSchema = z
  .object({
    companyUuid: z.uuid(),
    name: z.string(),
    onlyFrance: z.boolean(),
    nationalHolidays: z.boolean(),
    amountLimit: z.int(),
    typeLimit: typeLimitSchema,
    areOtherMerchantsAuthorized: z.boolean(),
    areSupportingDocumentsMandatory: z.boolean(),
    allowedCountries: z.array(countryCodeSchema),
    unauthorizedMerchantGroups: z.array(merchantGroupSchema),
    allowedPeriods: z.array(allowedPeriodSchema),
    canPayOnline: z.boolean(),
    categories: z.array(categoryItemSchema),
  })
  .strict();

export type CreateRulePayload = z.infer<typeof createRulePayloadSchema>;
